import { Brain, Crown, Monitor, UserCheck, Users, Zap } from "lucide-react";
import { SwotTabs } from "@/bizminer/App/PillarInsights/Swot/_components/SwotTabs.tsx";
import BizminerLayout from "@/bizminer/layouts/app/BizminerLayout.tsx";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { BizminerPillarInsight } from "@/types/serializers";

type Props = {
  pillar_insight: BizminerPillarInsight;
  account_name: string;
  current_competitor?: string;
};

const iconMap = {
  users: Users,
  "user-check": UserCheck,
  monitor: Monitor,
  crown: Crown,
  brain: Brain,
  zap: Zap,
};

const Empty = () => (
  <Card>
    <CardHeader>
      <CardTitle>Competitive Analysis</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-muted-foreground">
        SWOT analysis data will be available soon.
      </p>
    </CardContent>
  </Card>
);
export default function Swot({
  pillar_insight,
  current_competitor,
  account_name,
}: Props) {
  const IconComponent =
    iconMap[pillar_insight.icon as keyof typeof iconMap] || Users;

  return (
    <BizminerLayout>
      <div className="space-y-6">
        <div className="flex items-center space-x-3">
          <div className="flex size-12 items-center justify-center rounded-lg border border-border/50 bg-muted/30">
            <IconComponent className="h-7 w-7 text-primary" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-foreground">
              Competitive Analysis
            </h1>
            <p className="text-muted-foreground">{pillar_insight.title}</p>
          </div>
        </div>

        {pillar_insight.swot ? (
          <SwotTabs
            swotData={pillar_insight.swot}
            competitors={pillar_insight.competitors}
            currentCompetitor={current_competitor}
            pillarInsightId={pillar_insight.id}
            accountName={account_name}
          />
        ) : (
          <Empty />
        )}
      </div>
    </BizminerLayout>
  );
}
